import { render, staticRenderFns } from "./categoriesT3PDI.vue?vue&type=template&id=48786a5f"
import script from "./categoriesT3PDI.vue?vue&type=script&lang=js"
export * from "./categoriesT3PDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports